import React from "react";
import Moment from 'moment';
import { Badge } from 'reactstrap';
import axios from "axios";
import APIModel from "../Models/APIModel";

const getSearchUrlFromState = (o) => {
	let search = "?";

	Object.keys(o)
		.forEach(function eachKey(key) {
			search += key + "=" + o[key] + "&"
		});

	return search;
};

const upperCaseW = (text, sp = '_') => {
	return text.toLowerCase().split(sp).map((s) => s.charAt(0)
		.toUpperCase() + s.substring(1)).join(' ');
};

const isArray = (a) => {
	return (!!a) && (a.constructor === Array);
};

const can = (p, permissions, matchAll = false) => {

	if (p === undefined) {
		return true;
	}
	if (isArray(p)) {
		return canAll(p, permissions, matchAll);
	}
	return permissions.filter(v => v === p).length > 0;
};

const canAll = (ps, permissions, matchAll = false) => {

	let newArray = ps.filter(v => (can(v, permissions) === true));

	if (matchAll) {
		return newArray.length === ps.length;
	}

	return newArray.length > 0;
};

const filterNavLinks = (nav, permissions) => {

	nav.items = nav.items.filter(p => {
		if (p.children) {
			p.children = p.children.filter(c => can(c.permission, permissions));
		}
		return can(p.permission, permissions);
	});

	return nav;
};



const getRequestHeader = (token = null) => {

	if (token != null) {
		return ({
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json',
				'token': token
			}
		})

	}

	return ({
		headers: {
			'Content-Type': 'application/json',
			'Accept': 'application/json',
		}
	});
};

const getColorName = (colorId, colorList) => {
	for (let j = 0; j < colorList.length; j++) {
		if (colorId == colorList[j].ColorID) {
			return colorList[j].ColorName;
		}
	}
	return "";
};


const getGuardName = (guardID, guardslist) => {
	if (guardID == 0) {
		return "All Guards";
	}
	for (let j = 0; j < guardslist.length; j++) {
		if (guardID == guardslist[j].UserID) {
			return guardslist[j].FirstName + ' ' + guardslist[j].LastName + ' ( ' + guardslist[j].UserName + ' )';
		}
	}
	return "";
};


const getVisitorTypeByVisitorTypeId = (d, visitorsTypeList, colorList) => {
	// console.log(d);
	for (let i = 0; i < visitorsTypeList.length; i++) {
		if (d.VisitorTypeID == visitorsTypeList[i].VisitorTypeID) {
			if (visitorsTypeList[i].VisitorTypeDescription == 'Cone') {
				for (let j = 0; j < colorList.length; j++) {
					if (d.ConeColorID == colorList[j].ColorID) {
						return [
							<span><Badge color="primary" className="customBadgeForTable"> </Badge></span>,
							visitorsTypeList[i].VisitorTypeDescription + ' ( ' + d.ConeNumber + ' - ' + colorList[j].ColorName + ' )'
						];
					}
				}
			}

			if (visitorsTypeList[i].VisitorTypeDescription == 'Regulatory') {
				return [
					<span><Badge color="secondary" className="customBadgeForTable"> </Badge></span>,
					visitorsTypeList[i].VisitorTypeDescription + ' ( Organization: ' + d.Organization + ' - Pass: ' + d.PassNumber + ' - Location: ' + d.Location + ' )'
				];
			}
			if (visitorsTypeList[i].VisitorTypeDescription == 'Emergency') {
				return [
					<span><Badge color="success" className="customBadgeForTable"> </Badge></span>,
					visitorsTypeList[i].VisitorTypeDescription + ' ( Vehicle Type: ' + d.EmergencyVehicleType + ' - Unit: ' + d.UnitNo + ' - Sector: ' + d.SectionSector + ' )'
				];
			}

			if (visitorsTypeList[i].VisitorTypeDescription == 'Regular') {
				return [
					<span><Badge color="dark" className="customBadgeForTable"> </Badge></span>,
					// state
					visitorsTypeList[i].VisitorTypeDescription + ' ( License Plate: ' + d.LicensePlateNo + ' - ' + d.MakeName + ' ' + d.ColorName + ' ' + d.ModelName + ' )'
				];
			}
		}
	}

};

// const getDestinationDescription = (id, list) => {

// 	for (let j = 0; j< list.length; j++)
// 	{
// 		if (id == list[j].DestinationID)
// 		{
// 			return list[j].DestinationDescription;
// 		}
// 	}

// }

const getGateDescription = (gateID, gatesList) => {

	if (gateID == 0) {
		return "All Gates";
	}
	for (let i = 0; i < gatesList.length; i++) {
		if (gateID == gatesList[i].GateID) {
			return gatesList[i].GateDescription;
			break;
		}
	}
};

const getDestinationDescription = (destinationID, destinationsList) => {

	if (destinationID == 0) {
		return "All Gates";
	}
	for (let i = 0; i < destinationsList.length; i++) {
		if (destinationID == destinationsList[i].GateID) {
			return destinationsList[i].GateDescription;
			break;
		}
	}
};



const getSiteName = (SiteID, sitesList) => {

	if (SiteID == 0) {
		return "All Sites";
	}
	for (let i = 0; i < sitesList.length; i++) {

		if (SiteID == sitesList[i].SiteID) {
			return sitesList[i].SiteName;
		}
	}
	return "";
};



const getDateTimeFormat = (value, hours, br = null) => {
	if (br != null) {
		let date = Moment(value).local().format("MM-DD-YYYY");
		let time = Moment(value).local().format("hh:mm A");
		return <span><span> {date} </span> <br /> <span> {time} </span></span>;
	}
	else if (value != null || value != undefined) {
		return Moment(value).subtract(hours, 'hour').local().format("MM-DD-YYYY hh:mm A");
		// moment().subtract(1, 'hour').twitterLong();
	}
	else
		return <span></span>;
}

const getDateFormat = (value) => {
	if (value != null || value != undefined) {
		return Moment(value).local().format("MM-DD-YYYY");
	}
	else
		return <span></span>;
}

const getTimeFormat = (value) => {
	if (value != null || value != undefined) {
		return Moment(value).local().format("hh:mm A");
	}
	else
		return <span></span>;
}

const getTimesAgo = (value) => {
	// return  DateTime.Moment();
	// return value;

	// let today = Moment().format("MM-DD-YYYY hh:mm A");

	// return Moment(value).subtract(6, 'hour').local().format("MM-DD-YYYY hh:mm A")
	let CSTTime = Moment(value).subtract(6, 'hour').format("MM-DD-YYYY hh:mm A");
	return Moment(CSTTime).fromNow();

	// return Moment(today).from(CSTTime, true); // "a day ago"

	// return Moment().fromNow();
}

const renderDestinationCol = (id, list) => {
	for (let j = 0; j < list.length; j++) {
		if (id == list[j].DestinationID) {
			return <td>{list[j].DestinationDescription}</td>
		}
	}
}

const getStatusDescription = (id, list) => {
	for (let j = 0; j < list.length; j++) {
		if (id == list[j].VisitorStatusID) {
			if (list[j].VisitorStatusDescription == 'Block access to visitor') {
				return <td style={{ background: 'red', color: "#fff" }}>Blocked</td>
			}
			else {
				return <td>{list[j].VisitorStatusDescription}</td>
			}

		}
	}
}

const getStateName = (id, list) => {
	for (let j = 0; j < list.length; j++) {
		if (id == list[j].StateID) {
			return list[j].StateName;
		}
	}
}

const getVehicleTypeName = (id, list) => {
	for (let j = 0; j < list.length; j++) {
		if (id == list[j].VehicleTypeID) {
			return list[j].VehicleTypeName;
		}
	}
}

const getVisitorType = (id, list) => {
	// console.clear();
	for (let i = 0; i < list.length; i++) {
		if (id == list[i].VisitorTypeID) {
			return list[i].VisitorTypeDescription;
		}
	}
}
const getVehicleMakerName = (id, list) => {
	for (let i = 0; i < list.length; i++) {
		if (id == list[i].MakeID) {
			return list[i].MakeName;
		}
	}

}


const getTrailerTypeName = (id, list) => {
	for (let i = 0; i < list.length; i++) {
		if (id == list[i].TrailerTypeID) {
			return list[i].TrailerTypeDescription;
		}
	}

}

const getTrailerAttachmentName = (id, list) => {
	for (let i = 0; i < list.length; i++) {
		if (id == list[i].TrailerAttachmentID) {
			return list[i].TrailerAttachmentName;
		}
	}
}

const maskInput = (len, str) => {
	let expression = [];
	if (str == 0) {
		for (let i = 0; i < len; i++) {
			expression.push(/[A-Za-z]/);
		}
	}
	else {
		for (let i = 0; i < len; i++) {
			expression.push(/[0-9]/);
		}
	}
	return expression;
}


const getReportTypeNameById = (id, list) => {
	for (let i = 0; i < list.length; i++) {
		if (id == list[i].id) {
			return list[i].name;
		}
	}
}




// Api Calls

const getVisitorStatusList = () => {
	axios.get(APIModel.HOST + "Util/GetVisitorStatusList", getRequestHeader()
	).then(response => {
		return response.data;
	}).catch(this.errorHandler);
};

const getAllSites = () => {
	axios.get(APIModel.HOST + "Admin/GetSites", getRequestHeader()
	).then(response => {
		return response.data;
	}).catch("errorHandler");
};







export {
	getSearchUrlFromState,
	upperCaseW,
	can,
	filterNavLinks,
	getRequestHeader,
	getDateTimeFormat,
	getVisitorTypeByVisitorTypeId,
	getGateDescription,
	getDestinationDescription,
	getColorName,
	renderDestinationCol,
	getStatusDescription,
	getStateName,
	getVehicleTypeName,
	getVisitorType,
	getVehicleMakerName,
	getTrailerTypeName,
	getTrailerAttachmentName,
	getTimesAgo,
	getDateFormat,
	getTimeFormat,
	maskInput,
	getGuardName,
	getSiteName,
	getReportTypeNameById,

	// api functions
	getVisitorStatusList,
	getAllSites
}

